export default __webpack_public_path__ + "static/media/warehouse.147c9c0b.svg";